export enum KindEnum {
    PREFIX = "prefix",
    BLOB = "blob"
   }